module.exports = __webpack_public_path__ + "img/pic_hot_empty@2x.798913b9.png";